import { object, string, number } from 'yup';

export default object({
    name: string(),
    address: string(),
    postal_code: string(),
    city: string(),
    country_id: number(),
});
